// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"475":"MainPage","495":"MainDashboard","789":"LoginPage","846":"RegisterPage"}[chunkId] + "." + {"475":"e6c9e1e7","495":"2481ffde","789":"1ab19d5c","846":"9900ccf0"}[chunkId] + ".css";
};